import {useHistory, useParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import DettaglioDocumentoArchivioView from "./DettaglioDocumentoArchivioView";
import {LoaderContext} from "../../context/LoaderContext";
import {RuoliContext} from "../../context/RuoliContext";
import {FiltersContext} from "../../context/FiltersContext";
import {deleteDocumentoApi, getDocumentoArchivioByIdApi} from "../../services/ArchivioServices";

export default function DettaglioDocumentoArchivioController({}) {
    const {idDocumento} = useParams()

    const [documento, setDocumento] = useState();
    const [showConfirmDelDocumento, setShowConfirmDelDocumento] = useState(false);
    const [showModalUpdateDocumento, setShowModalUpdateDocumento] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {filtroArchivio} = useContext(FiltersContext);
    const {
        isRuoloSocio,
        isRuoloClub,
        isRuoloAgenzia,
    } = useContext(RuoliContext);
    const history = useHistory();

    async function getDocumento() {
        startChiamata();
        var response = await getDocumentoArchivioByIdApi(idDocumento);
        endChiamata();

        setDocumento(response.data.data);
    }

    useEffect(() => {
        if (idDocumento) {
            getDocumento();
        }
    }, [idDocumento]);

    function handlerModificaDocumento() {
        if (documento) {
            setShowModalUpdateDocumento(true);
        }
    }

    function handlerEliminaDocumento() {
        if (documento) {
            setShowConfirmDelDocumento(true);
        }
    }

    async function eliminaDocumento() {
        if (documento) {
            const filtri = getStrFiltroDocumenti();

            startChiamata();
            const response = await deleteDocumentoApi(documento.id_archivio_documento, filtri);
            endChiamata();

            if (response.data.result == '0') {
                history.goBack();
            } else {
                // TODO errore
            }
        }
    }

    function getStrFiltroDocumenti() {
        let f = '';

        if (filtroArchivio['id_archivio_marca'] && filtroArchivio['id_archivio_marca'] !== '') {
            f += `${f === '' ? '?' : '&'}id_archivio_marca=${filtroArchivio['id_archivio_marca']}`;
        }
        if (filtroArchivio['marca'] && filtroArchivio['marca'] !== '') {
            f += `${f === '' ? '?' : '&'}marca=${filtroArchivio['marca']}`;
        }
        if (filtroArchivio['modello'] && filtroArchivio['modello'] !== '') {
            f += `${f === '' ? '?' : '&'}modello=${filtroArchivio['modello']}`;
        }
        if (filtroArchivio['inizioProd'] && filtroArchivio['inizioProd'] !== '') {
            f += `${f === '' ? '?' : '&'}inizioProd=${filtroArchivio['inizioProd']}`;
        }
        if (filtroArchivio['fineProd'] && filtroArchivio['fineProd'] !== '') {
            f += `${f === '' ? '?' : '&'}fineProd=${filtroArchivio['fineProd']}`;
        }
        if (filtroArchivio['dataDocDa'] && filtroArchivio['dataDocDa'] !== '') {
            f += `${f === '' ? '?' : '&'}dataDocDa=${filtroArchivio['dataDocDa']}`;
        }
        if (filtroArchivio['dataDocA'] && filtroArchivio['dataDocA'] !== '') {
            f += `${f === '' ? '?' : '&'}dataDocA=${filtroArchivio['dataDocA']}`;
        }
        return f;
    }

    return (
        <DettaglioDocumentoArchivioView
            documento={documento}
            isAdmin={!isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia()}
            handlerModificaDocumento={handlerModificaDocumento}
            handlerEliminaDocumento={handlerEliminaDocumento}
            showConfirmDelDocumento={showConfirmDelDocumento}
            setShowConfirmDelDocumento={setShowConfirmDelDocumento}
            eliminaDocumento={eliminaDocumento}
            showModalUpdateDocumento={showModalUpdateDocumento}
            closeModalUpdateDocumento={() => setShowModalUpdateDocumento(false)}
            updateDocumentoOk={getDocumento}
        />
    );

}